import { ErrorHandler, Injectable, inject } from "@angular/core";
import * as Sentry from "@sentry/angular";
import { GlobalErrorService } from "./ErrorService";

/**
 * Replaces Angular's default ErrorHandler to bridge uncaught runtime errors into UI state.
 * Logs to the console for diagnostics, reports to GlitchTip (no-op if not initialized), then
 * forwards the error into GlobalErrorService so the error boundary overlay can render a
 * recovery experience instead of a broken view.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly globalErrorService = inject(GlobalErrorService);

  handleError(error: unknown): void {
    console.error(error);
    Sentry.captureException(error);
    this.globalErrorService.setError(error);
  }
}
